import { Directive, OnInit, ElementRef, Renderer2, HostListener } from "@angular/core";
import { Subscription } from "rxjs";
import { KeyboardService } from "src/app/services/keyboard.service";

@Directive({
  selector: '[appOskNumberinput]'
})
export class OskNumberinputDirective {
  private keySubscription: Subscription;
  private backspaceSubscription: Subscription;
  private enterSubscription: Subscription;
  private measure: HTMLElement;
  private inputValue: string = '';
  private inputType: string = '';

  constructor(private el: ElementRef, private keyboard: KeyboardService, private renderer: Renderer2) { }

  ngOnInit() {
    // TODO I'm sure there's an "Angular way" of doing this
    let thisStyle = window.getComputedStyle(this.el.nativeElement);
    this.measure = document.createElement("span");
    this.measure.style.position = "absolute";
    this.measure.style.right = "100%";
    this.measure.style.font = thisStyle.font;
    document.body.appendChild(this.measure);
    this.keyboard.setkeyboardtype('number');
    // Inicializa inputValue con el valor actual del input
    this.inputValue = this.el.nativeElement.value;
  }

  @HostListener("focus")
  private onFocus() {
    this.keyboard.fireKeyboardRequested(true);
    this.keyboard.updateKeyboardInput(this.inputValue);
    this.subscribeToKeyboardEvents();

  }

  @HostListener("blur")
  private onBlur() {
    this.keyboard.fireKeyboardRequested(false);
    this.unsubscribeFromKeyboardEvents();
  }

  private subscribeToKeyboardEvents() {
    this.keySubscription = this.keyboard.keyPressed.subscribe(key =>
      this.onKey(key)
    );
    this.backspaceSubscription = this.keyboard.backspacePressed.subscribe(_ =>
      this.onBackspace()
    );
    this.enterSubscription = this.keyboard.enterPressed.subscribe(_ =>
      this.onEnter()
    );
  }

  private unsubscribeFromKeyboardEvents() {
    this.keySubscription.unsubscribe();
    this.backspaceSubscription.unsubscribe();
    this.enterSubscription.unsubscribe();
  }

  /* private onKey(key: string) {
     // TODO Refactor this into a single method with the code in onBackspace
     let element = this.el.nativeElement,
       start = element.selectionStart,
       end = element.selectionEnd;


     // Actualiza el valor del input utilizando Renderer2
     const newValue = element.value.slice(0, start) + key + element.value.slice(end);
     this.renderer.setProperty(element, 'value', newValue);

     // Dispara un evento de cambio para notificar a Angular
     const event = new Event('input', { bubbles: true });
     element.dispatchEvent(event);

     // Actualiza la variable inputValue con el nuevo valor del input
     this.inputValue = newValue;
     this.updateScrollPosition();
     this.keyboard.updateKeyboardInput(newValue);
   }
 */

  private onKey(key: string) {
    const element = this.el.nativeElement;
    const currentValue = element.value;
    const start = element.selectionStart;
    const end = element.selectionEnd;

    let newValue: string; // Declarar la variable newValue

    // Verificar si start y end son nulos
    if (start === null || end === null) {
      // No hay selección activa, agregar el carácter al final
      newValue = currentValue + key;
      this.renderer.setProperty(element, 'value', newValue);
      this.inputValue = newValue;
    } else {
      // Actualiza el valor del input utilizando Renderer2
      newValue = currentValue.slice(0, start) + key + currentValue.slice(end);

      this.renderer.setProperty(element, 'value', newValue);

      // Calcula la nueva posición del cursor (al final del carácter ingresado)
      const newCursorPosition = start + 1;

      // Actualiza la variable inputValue con el nuevo valor del input
      this.inputValue = newValue;

      // Ajusta la posición del cursor después de actualizar el valor del campo
      element.setSelectionRange(newCursorPosition, newCursorPosition);
    }

    // Dispara un evento de cambio para notificar a Angular
    const event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);

    this.updateScrollPosition();
    this.keyboard.updateKeyboardInput(newValue); // Utiliza newValue aquí
  }


  private updateScrollPosition() {
    let element = this.el.nativeElement;
    element.scrollLeft = this.measure.offsetWidth - (element.clientWidth - 10);
  }

  private onEnter() {
    this.onBlur();

  }


  private onBackspace() {
    const element = this.el.nativeElement;
    const currentValue = element.value;
    let start = element.selectionStart;
    let end = element.selectionEnd;

    if (start === null || end === null) {
      // No hay selección activa, eliminar el carácter a la izquierda del cursor
      if (start === 0) {
        // El cursor ya está al principio, no se puede eliminar más
        return;
      }

      start--; // Retrocede una posición
      end = element.selectionStart; // Ajusta el valor de "end" para que sea igual a "start"
    }

    // Actualiza el valor del input utilizando Renderer2
    //const newValue = currentValue.slice(0, start) + currentValue.slice(end);
    const newValue = currentValue.slice(0, -1);

    this.renderer.setProperty(element, 'value', newValue);
    this.inputValue = newValue;

    // Ajusta la posición del cursor después de actualizar el valor del campo
    //element.setSelectionRange(start, start);

    // Dispara un evento de cambio para notificar a Angular
    const event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);

    this.updateScrollPosition();
    this.keyboard.updateKeyboardInput(newValue); // Utiliza newValue aquí
  }
}
